import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
export default function StarfieldBackground() {
    useEffect(() => {
        const starfield = document.getElementById('starfield');
        if (!starfield)
            return;
        const numberOfStars = 150;
        for (let i = 0; i < numberOfStars; i++) {
            const star = document.createElement('div');
            star.className = 'star';
            // Random positioning
            star.style.left = Math.random() * 100 + '%';
            star.style.top = Math.random() * 200 + '%';
            // Random size and opacity
            const size = Math.random() * 3 + 1;
            star.style.width = size + 'px';
            star.style.height = size + 'px';
            star.style.opacity = String(Math.random() * 0.8 + 0.2);
            // Random animation duration
            star.style.animationDuration = (Math.random() * 100 + 50) + 's';
            star.style.animationDelay = Math.random() * 100 + 's';
            starfield.appendChild(star);
        }
        return () => {
            if (starfield) {
                starfield.innerHTML = '';
            }
        };
    }, []);
    return _jsx("div", { id: "starfield", className: "starfield" });
}
